import { render } from "./ResourceStat.vue?vue&type=template&id=1930c2b2&scoped=true"
import script from "./ResourceStat.vue?vue&type=script&lang=js"
export * from "./ResourceStat.vue?vue&type=script&lang=js"

import "./ResourceStat.vue?vue&type=style&index=0&id=1930c2b2&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1930c2b2"]])

export default __exports__